import {
    addNewRowToTable,
    convertUniversalDateTimeToPersianDateTime,
    DialogSize,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoCustomSimpleActiveDeActiveChip,
    RaikoCustomTable,
    RaikoDefaultDialogPage,
    RaikoGridOneColumn,
    RaikoTableTitleContainer,
    showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {RouteHelper} from "../../route/RouteHelper";
import React, {useEffect, useState} from "react";
import {Helmet} from "react-helmet";
import {css} from "@emotion/css";
import {VowService} from "../../serverService/vow/VowService";
import VowAddNew from "./VowAddNew";
import {useNavigate} from "react-router-dom";

export default function VowList() {

    let page = 0
    const size = 20

    const service = new VowService();

    const [numberOfItems, setNumberOfItems] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [vowList, setVowList] = useState([])
    const [pageCount, setPageCount] = useState(0)

    const navigate = useNavigate();

    useEffect(() => {
        getDataFromServer()
    }, []);

    function prepareVowTableItem(number, id, title, createdAt, createdBy, enabled) {
        return {
            number,
            id,
            title,
            createdAt: convertUniversalDateTimeToPersianDateTime(createdAt),
            createdBy,
            enabled: <RaikoCustomSimpleActiveDeActiveChip
                state={enabled}
                activeStateTitle={"منتشر شده"}
                deActiveStateTitle={"پیشنویس"}
            />
        }
    }

    function getDataFromServer() {
        setIsLoading(true);
        service.getVowList(page, size)
            .then(response => {
                setPageCount(response.totalPage)
                setNumberOfItems(response.numberOfItems)

                setVowList([])
                response.data.map((vow, index) => {
                    setVowList(prevState => [
                        ...prevState,
                        prepareVowTableItem(
                            (page * size) + index + 1,
                            vow.id,
                            vow.title,
                            vow.createdAt,
                            vow.createdBy,
                            vow.enabled
                        )
                    ])
                })

            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setIsLoading(false);
        })
    }


    const [openDialog, setOpenDialog] = useState(false);
    const handleOpenDialog = () => setOpenDialog(true);
    const handleCloseDialog = () => setOpenDialog(false);

    function handleChangePagination(newPage) {
        page = newPage
    }

    function showVowDetail(id) {
        let _title = ""
        vowList.map((item) => {
            if (item.id === id)
                _title = item.title
        })


        navigate(
            RouteHelper.VowDetail.globalUrl.replace(":id", id),
            {state: {title: _title}, replace: false}
        )
    }

    function handleAddNewItemToTable(vow) {
        const _vowList = addNewRowToTable(prepareVowTableItem(
            1,
            vow.id,
            vow.title,
            vow.createdAt,
            vow.createdBy,
            vow.enabled
        ), vowList);

        setVowList(_vowList);
        handleCloseDialog()
    }

    return (
        <>
            <Helmet>
                <title>{RouteHelper.VowList.name}</title>
            </Helmet>
            <RaikoDefaultDialogPage
                onClose={handleCloseDialog}
                open={openDialog}
                pageTitle={""}
                hasCloseButton={false}
                dialogSize={DialogSize.SMALL}
            >
                <VowAddNew handleAddNewItemToTable={handleAddNewItemToTable}/>
            </RaikoDefaultDialogPage>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                    {
                        <RaikoBreadcrumb breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(RouteHelper.Vow.name, ""),
                            raikoBreadCrumbItemGenerator(RouteHelper.VowList.name, ""),
                        ]}/>
                    }
                </RaikoGridOneColumn>

                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoTableTitleContainer
                            title={"نذورات"}
                            amount={numberOfItems}
                            hasCreateNewItem
                            handleCreateNewItem={handleOpenDialog}
                        />
                        <RaikoCustomTable
                            isLoading={isLoading}
                            data={vowList}
                            header={header}
                            handlePaginationChange={handleChangePagination}
                            pageCount={pageCount}
                            rowClicked={showVowDetail}
                        />
                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>
            </RaikoBaseContainer>
        </>
    )
}


const header = [
    {
        id: "number",
        label: "#"
    },
    {
        id: "title",
        label: "عنوان"
    },
    {
        id: "createdBy",
        label: "سازنده"
    },
    {
        id: "createdAt",
        label: "تاریخ ساخت"
    },
    {
        id: "enabled",
        label: "وضعیت"
    },
]